import { Client } from '@/utils';
import { resource as resourceAPI } from '@/api';

const LOAD_RESOURCE = 'resourceDev/LOAD_RESOURCE';
const LOAD_BACKURLS = 'resourceDev/LOAD_BACKURLS';
const CREATE_RESOURCE = 'resourceDev/CREATE_RESOURCE';
const EDIT_RESOURCE = 'resourceDev/EDIT_RESOURCE';
const EDIT_DEV = 'resourceDev/EDIT_DEV';
const DELETE_RESOURCE = 'resourceDev/DELETE_RESOURCE';
const TOGGLE_FOLD = 'resourceDev/TOGGLE_FOLD';
const TOGGLE_HIDE = 'resourceDev/TOGGLE_HIDE';
const TOGGLE_LOADED = 'resourceDev/TOGGLE_LOADED';
const TOGGLE_REFRESHING = 'resourceDev/TOGGLE_REFRESHING';

function getResourceList(resList) {
  let resourceList = [];
  resList.forEach((item) => {
    const hasChildren = item.resType < 4 && item.children && item.children.length > 0;
    resourceList.push({
      ...item,
      hasChildren,
      isFold: false,
      isHide: false,
    });
    if (hasChildren && item.resType < 4) {
      resourceList = resourceList.concat(getResourceList(item.children));
    }
  });
  return resourceList;
}

// 获取子节点下标
function getChildrenIndex(data, parentLevel, parentIndex) {
  let childrenIndex = [];
  for (let i = parentIndex + 1; i < data.length; i++) {
    if (data[i].resType <= parentLevel) {break};
    if (data[i].resType - 1 === parentLevel) {
      childrenIndex.push(i);
    }
  }
  const len = childrenIndex.length; // important!!!
  if (len > 0) {
    for (let i = 0; i < len; i++) {
      const childData = data[childrenIndex[i]];
      if (childData.hasChildren) {
        childrenIndex = childrenIndex.concat(
          getChildrenIndex(data, childData.resType, childrenIndex[i]));
      }
    }
  }
  return childrenIndex;
}

export default {
  state: {
    loaded: false,
    refreshing: false,
    activeTab: '',
    systemResources: [],
    backurls: '',
    sync: false,
    runEvn: 'preprod',
  },
  actions: {
    async [LOAD_RESOURCE]({ commit }, { params = {}, frontCode = '' } = {}) {
      commit(LOAD_RESOURCE, await Client.get(resourceAPI.query, { params }, frontCode));
    },
    async [LOAD_BACKURLS]({ commit }, { params = {}, frontCode = '' } = {}) {
      commit(LOAD_BACKURLS, await Client.get(resourceAPI.urlQuery, { params }, frontCode));
    },
    async [CREATE_RESOURCE]({ commit }, { data = {}, index, frontCode = '' }) {
      commit(CREATE_RESOURCE, {
        index,
        data: await Client.post(resourceAPI.create, { data }, frontCode),
      });
    },
    async [EDIT_RESOURCE]({ commit }, { data = {}, $index, index, frontCode = '' }) {
      commit(EDIT_RESOURCE, {
        index,
        $index,
        data: await Client.post(resourceAPI.update, { data }, frontCode),
      });
    },
    async [EDIT_DEV]({ commit }, { data = {}, $index, index, frontCode = '' }) {
      commit(EDIT_DEV, {
        index,
        $index,
        data: await Client.post(resourceAPI.devUpdate, { data }, frontCode),
      });
    },
    async [DELETE_RESOURCE]({ commit }, {
      data = {}, children, resType, parentId, $index, index, frontCode = '',
    }) {
      const { resId } = data;
      await Client.post(resourceAPI.delete, { data }, frontCode);
      commit(DELETE_RESOURCE, {
        index,
        $index,
        resId,
        parentId,
        resType,
        children,
      });
    },
  },
  /* eslint-disable no-param-reassign, max-len */
  mutations: {
    [LOAD_RESOURCE](state, { sysList, currentSysId, resList, sync,runEvn}) {
      if (sysList.length === 0) {
        state.systemResources = [];
      } else {
        const hasChildren = resList && resList.length > 0;
        const systemResources = sysList.map(item => ({
          id: item.bizId,
          name: item.resName,
          resourceList: [{
            ...item,
            hasChildren,
          }],
        }));
        for (let i = 0; i < systemResources.length; i++) {
          if (systemResources[i].id === currentSysId) {
            if (hasChildren) {
              systemResources[i].resourceList = systemResources[i].resourceList.concat(getResourceList(resList));
            }
            break;
          }
        }
        state.activeTab = currentSysId.toString();
        state.systemResources = systemResources;
        state.sync = sync || false;
        state.runEvn = runEvn || 'preprod';
        
      }
    },
    [LOAD_BACKURLS](state, data) {
      state.backurls = data;
    },
    [CREATE_RESOURCE](state, { index: $index, data }) {
      const { id, bizId, parentResId, resName, resType } = data;
      const resourceList = $index !== '' ? state.systemResources[$index].resourceList : '';
      if (resType === 1) {
        state.systemResources.push({
          id: bizId,
          name: resName,
          resourceList: [{
            ...data,
            hasChildren: false,
            isFold: false,
          }],
        });
        state.activeTab = bizId.toString();
      } else if (resType === 2) {
        if (resourceList.length === 1) {
          resourceList[0].hasChildren = true;
        }
        resourceList.push({
          ...data,
          hasChildren: false,
          isFold: false,
        });
      } else {
        let index;
        for (let i = 0; i < resourceList.length; i++) {
          if (resourceList[i].bizId === parentResId) {
            if (!resourceList[i].children) {
              resourceList[i].children = [];
              resourceList[i].hasChildren = true;
            }
            resourceList[i].children.push(data);
            index = i;
            break;
          }
        }
        let num = 1;
        if (index) {
          num += index;
        }
        resourceList.splice(num, 0, {
          ...data,
          hasChildren: false,
          isFold: false,
          isHide: resourceList[index].isFold,
        });
      }
    },
    [DELETE_RESOURCE](state, { index, $index, resId, parentId, resType, children }) {
      const targetList = state.systemResources[index].resourceList;
      if (children && children.length > 0) {
        const childrenIndex = getChildrenIndex(targetList, resType, $index);
        targetList.splice($index + 1, childrenIndex.length);
      }
      targetList.splice($index, 1);
      if (resType !== 2) {
        let parentResource = {};
        for (let i = 0; i < targetList.length; i++) {
          if (targetList[i].id === parentId) {
            parentResource = targetList[i];
            break;
          }
        }
        let parentChildren = [];
        if (parentResource.children) {
          parentChildren = parentResource.children;
        }
        for (let i = 0; i < parentChildren.length; i++) {
          if (parentChildren[i].id === resId) {
            parentChildren.splice(i, 1);
            if (parentChildren.length === 0) {
              parentResource.isFold = false;
              parentResource.hasChildren = false;
            }
            break;
          }
        }
      } else if (targetList.length === 1) {
        targetList[0].hasChildren = false;
        targetList[0].isFold = false;
      }
    },
    [TOGGLE_HIDE](state, { index, $index }) {
      const targetList = state.systemResources[index].resourceList;
      targetList[$index].isHide = !targetList[$index].isHide;
    },
    [TOGGLE_FOLD](state, { index, $index }) {
      const targetList = state.systemResources[index].resourceList;
      targetList[$index].isFold = !targetList[$index].isFold;
    },
    [EDIT_RESOURCE](state, { index, $index, data }) {
      const targetList = state.systemResources[index].resourceList;
      targetList.splice($index, 1, {
        ...targetList[$index],
        ...data,
      });
      if ($index === 0) {
        state.systemResources[index].name = data.resName;
      }
    },
    [EDIT_DEV](state, { index, $index, data }) {
      const targetList = state.systemResources[index].resourceList;
      targetList.splice($index, 1, {
        ...targetList[$index],
        ...data,
      });
    },
    [TOGGLE_LOADED](state, data) {
      state.loaded = data;
    },
    [TOGGLE_REFRESHING](state, data) {
      state.refreshing = data;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/resourceDev.js